export default function (number: number) {
    return Intl.NumberFormat('ro-RO', {
        notation: 'compact',
        maximumFractionDigits: 2
    }).format(number)
}
